import { useQuery } from '@tanstack/react-query'
import getHints from '../../services/ruutsApi/v2/quantificationUnits/getHints'
import { QUHintsResponse } from '../../types/apiModels'
import { queryKeys } from './queryKeys'

type UseQUHintsParams = {
  farmId: string | undefined
  year?: string
  enabled: boolean
}

type UseQUHintsResult = {
  data: QUHintsResponse | null
  isLoading: boolean
  refetch: () => Promise<unknown>
}

// Loteo years include non-period values like 'TEMPLATE'; the hints endpoint 400s on any year that isn't 4 digits.
const isValidYear = (year: string | undefined): boolean => !year || /^\d{4}$/.test(year)

export const useQUHints = ({ farmId, year, enabled }: UseQUHintsParams): UseQUHintsResult => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: queryKeys.quHints(farmId, year),
    queryFn: ({ signal }) => getHints({ farmId: farmId as string, year, signal }),
    enabled: enabled && !!farmId && isValidYear(year),
  })

  return { data: data ?? null, isLoading, refetch }
}
